module.exports = __webpack_public_path__ + "31af68eb2da00845046959407961bbd5.png";